import React from "react";
import { Stack, Group, Text } from "@mantine/core";
import { IconTrophy, IconCurrencyDollar, IconPhoto } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

export default function LootItemIndicators({
  hasAsset,
  quantityAllocated,
  value,
}) {
  const { t } = useTranslation();
  const iconProps = {
    size: 16,
    color: "black",
    variant: "light",
    radius: "xl",
  };

  const items = [
    {
      value: hasAsset
        ? t("mixer:loot_item:image_uploaded")
        : t("mixer:loot_item:no_image_uploaded"),
      icon: <IconPhoto {...iconProps} />,
      color: hasAsset ? "green" : "grey",
    },
    {
      value: `${quantityAllocated} ${t("mixer:loot_item:allocated")}`,
      icon: <IconTrophy {...iconProps} />,
      color: quantityAllocated > 0 ? "black" : "grey",
    },
    {
      value: value,
      icon: <IconCurrencyDollar {...iconProps} />,
      color: "black",
    },
  ];

  return (
    <Stack gap={2}>
      {items.map((item, i) => (
        <div key={i}>
          <Group style={{ color: item.color }} size="lg">
            {item.icon}
            <Text size="sm">{item.value}</Text>
          </Group>
        </div>
      ))}
    </Stack>
  );
}
